import { MemoryPerformanceTab } from "..";

export const MemoryPerformanceScreenBody = (data: any) => {
  return (
    <>
      <MemoryPerformanceTab data={data[0]} lineData={data[1]} />
    </>
  );
};
